"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataArraysToRecord = metadataArraysToRecord;
exports.parseMetadataCHRecordToDomain = parseMetadataCHRecordToDomain;
const json_1 = require("../../utils/json");
/**
 * Zips parallel ClickHouse array columns (`metadata_names`, `metadata_values`)
 * into a plain object. If a key appears more than once the **first** occurrence
 * wins, matching the ClickHouse `mapFromArrays(arrayReverse(...))` convention.
 *
 * Returns `undefined` when the names array is empty so callers can distinguish
 * "no metadata" from "empty metadata object".
 */
function metadataArraysToRecord(names, values) {
    if (names.length === 0)
        return undefined;
    return names.reduce((acc, name, i) => {
        if (!(name in acc)) {
            acc[name] = values[i];
        }
        return acc;
    }, {});
}
function parseMetadataCHRecordToDomain(metadata) {
    return metadata
        ? Object.fromEntries(Object.entries(metadata ?? {}).map(([key, val]) => [
            key,
            val === null ? null : (0, json_1.parseJsonPrioritised)(val),
        ]))
        : {};
}
